import React,{useState,useEffect} from "react";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  // Tooltip,
  // Legend,
} from "recharts";
import "./Home.css";
import api from "../services/api";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { FaBookOpen, FaDollarSign } from "react-icons/fa";
import { CgShoppingCart } from "react-icons/cg";
import { HiLibrary } from "react-icons/hi";
import { color } from "chart.js/helpers";
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const taskStatusData = [
  { name: "Completed", value: 220 },
  { name: "In Progress", value: 80 },
  { name: "Pending", value: 40 },
];

const leaveData = [
  { name: "Granted", value: 18 },
  { name: "Pending", value: 6 },
];

const attendanceData = [
  { name: "Present", value: 120 },
  { name: "Absent", value: 10 },
  { name: "On Leave", value: 5 },
];

// const COLORS_TASK = ["#28a745", "#17a2b8", "#ffc107"]; // green, cyan, yellow
// const COLORS_LEAVE = ["#28a745", "#ffc107"];
// const COLORS_ATT = ["#007bff", "#dc3545", "#6f42c1"]; // blue, red, purple

const SummaryCard = ({ title, value, hint ,bgColor}) => (
  <div className="card summary-card"
  style={{ backgroundColor: bgColor }}
  >
    <div className="card-body">
      <h5 className="card-title text-secondary-emphasis">{title}</h5>
      <div className="card-value text-secondary-emphasis">{value}</div>
      {hint && <div className="card-hint">{hint}</div>}
    </div>
  </div>
);


const Home = () => {
  const totalTasks = taskStatusData.reduce((s, d) => s + d.value, 0);
  const totalLeaves = leaveData.reduce((s, d) => s + d.value, 0);
  const totalAttendance = attendanceData.reduce((s, d) => s + d.value, 0);
   const [dashboard, setDashboard] = useState({});

   useEffect(() => {
    fetchPurchases();
  }, []);

  const fetchPurchases = async () => {
    try {

      const response = await api.post("/dashboard.php", {});

      if (response.data.head.code === 200) {
        // Transform the data
        setDashboard(response.data.body);
      } else if (response.data.head.code === 606) {
        // No purchases found - set empty array
        setDashboard([]);
      } else {
        // setError(response.data.head.msg || "Failed to fetch purchases");
      }
    } catch (err) {
      console.error("Error fetching purchases:", err);
      // setError("Failed to load purchases. Please try again.");
    } finally {
      // setLoading(false);
    }
  };

const dataCards = [
    {
      title: "Total Customers",
      value: dashboard.total_customer,
      icon: <FaDollarSign size={30} />,
      bg: "linear-gradient(135deg, #ff6a00, #ffb347)",
      prefix: "₹ ",
    },
    {
      title: "Total Orders",
      value: dashboard.total_order,
      icon: <CgShoppingCart size={30} />,
      bg: "linear-gradient(135deg, #43cea2, #185a9d)",
    },
    {
      title: "Total Delivery Note",
      value: dashboard.total_delivery_note,
      icon: <FaBookOpen size={30} />,
      // bg: "linear-gradient(135deg, #ff512f, #dd2476)",
      bg: "linear-gradient(135deg, #ccf224ff, #a6c90aff)",
    },
    {
      title: "Total Invoice",
      value: dashboard.total_invoice,
      icon: <HiLibrary size={30} />,
      // bg: "linear-gradient(135deg, #174233ff, #67ad81ff)",
      // bg: "linear-gradient(135deg, #ccf224ff, #a6c90aff)",
    },
    // {
    //   title: "Total Customers",
    //   value: stats.total_customers,
    //   icon: <Users size={30} />,
    //   bg: "linear-gradient(135deg, #fab5c0ff, #fa7d34ff)",
    // },
    // {
    //   title: "Total Subscribers",
    //   value: stats.total_subscribers,
    //   icon: <Users size={30} />,
    //   bg: "linear-gradient(135deg, #f46febff, #bf20f4ff)",
    // },
    // {
    //   title: "Monthly Subscribers",
    //   value: stats.total_monthly_subscribers,
    //   icon: <Users size={30} />,
    //   bg: "linear-gradient(135deg, #61c871ff, rgba(39, 185, 13, 1))",
    // },
    // {
    //   title: "Yearly Subscribers",
    //   value: stats.total_yearly_subscribers,
    //   icon: <Users size={30} />,
    //   bg: "linear-gradient(135deg, #ccf224ff, #a6c90aff)",
    // },
  ];
// Chart Data
  const chartData = {
    labels: dataCards.map((c) => c.title),
    datasets: [
      {
        label: "Stats",
        data: dataCards.map((c) => Number(c.value)),
        backgroundColor: [
          "#ff8808",
          "#43cea2",
          "#ff512f",
          "#ccf224ff",
          "#67ad81",
          "#fa7d34",
          "#bf20f4ff",
          "rgba(39, 185, 13, 1)",
          
        ],
        borderRadius: 6,
      },
    ],
  };
const chartOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
      title: { display: true, text: "Dashboard Stats Overview" },
    },
  };
  return (
    <div className="dashboard">
      <h2 className="dashboard-title">Dashboard Overview</h2>

      <div className="card-container">
        <SummaryCard title="Total Customers" value={dashboard.total_customer} bgColor="#f8c997" />
        <SummaryCard title="Total Orders" value={dashboard.total_order} bgColor="#9ef8dc"/>
        <SummaryCard title="Total Delivery Note" value={dashboard.total_delivery_note} bgColor="#f7afa1"/>
        <SummaryCard title="Total Invoice" value={dashboard.total_invoice} bgColor="rgb(240, 250, 193)"/>
        {/* <SummaryCard title="Total Delivery Note" value={totalLeaves} hint={`${leaveData[0].value} granted`} />
        <SummaryCard title="Total Invoice" value={totalTasks} hint={`${taskStatusData[0].value} completed`} /> */}
      </div>
{/*
      <div className="charts-row">
        <div className="chart-card">
          <h4 className="chart-title">Task Status</h4>
          <ResponsiveContainer width="100%" height={240}>
            <PieChart>
              <Pie
                data={taskStatusData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={70}
                innerRadius={38}
                paddingAngle={4}
                label={(entry) => `${Math.round((entry.value / totalTasks) * 100)}%`}
                labelLine={false}
              >
                {taskStatusData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS_TASK[index % COLORS_TASK.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend verticalAlign="bottom" height={36} />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div className="chart-card">
          <h4 className="chart-title">Leave Status</h4>
          <ResponsiveContainer width="100%" height={240}>
            <PieChart>
              <Pie
                data={leaveData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={70}
                innerRadius={40}
                paddingAngle={4}
                label={(entry) => `${Math.round((entry.value / totalLeaves) * 100)}%`}
                labelLine={false}
              >
                {leaveData.map((entry, index) => (
                  <Cell key={`cell-leave-${index}`} fill={COLORS_LEAVE[index % COLORS_LEAVE.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend verticalAlign="bottom" height={36} />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div className="chart-card">
          <h4 className="chart-title">Attendance</h4>
          <ResponsiveContainer width="100%" height={240}>
            <PieChart>
              <Pie
                data={attendanceData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={70}
                innerRadius={36}
                paddingAngle={4}
                label={(entry) => `${Math.round((entry.value / totalAttendance) * 100)}%`}
                labelLine={false}
              >
                {attendanceData.map((entry, index) => (
                  <Cell key={`cell-att-${index}`} fill={COLORS_ATT[index % COLORS_ATT.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend verticalAlign="bottom" height={36} />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
      */}
       <div className="mt-5">
        <Bar data={chartData} options={chartOptions} />
      </div>
    </div>
  );
};

export default Home;
